import React from "react";
import { Box, Grid, Typography, Card, CardContent, Avatar } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SchoolIcon from "@mui/icons-material/School";
import VerifiedIcon from "@mui/icons-material/Verified";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
const features = [
  {
    icon: <LockIcon fontSize="large"  />,
    title: "Top-Notch Papers",
    description:
      "Our professional writers deliver 100% plagiarism-free essays tailored to your instructions. We ensure compliance with academic standards and provide quality assurance for originality.",
  },
  {
    icon: <CheckCircleIcon fontSize="large" />,
    title: "Timely Delivery",
    description:
      "Get your assignments on time, with turnarounds starting from just one hour for short projects. Larger projects are handled with precision and efficient communication.",
  },
  {
    icon: <LockIcon fontSize="large" />,
    title: "24/7/365 Support",
    description:
      "We provide round-the-clock assistance to address your questions or concerns. Our dedicated support team ensures seamless communication and service delivery.",
  },
  {
    icon: <SchoolIcon fontSize="large" />,
    title: "Subject Expertise",
    description:
      "Our team includes experts across various academic fields, ensuring your assignments meet the highest standards of subject accuracy and depth.",
  },
  {
    icon: <VerifiedIcon fontSize="large" />,
    title: "Affordable Pricing",
    description:
      "We offer competitive rates for assignment writing without compromising on quality, making professional help accessible to all students.",
  },
  {
    icon: <AssignmentTurnedInIcon fontSize="large" />,
    title: "Customized Solutions",
    description:
      "Every assignment is tailored to your unique requirements, delivering personalized content that aligns with your academic goals and guidelines.",
  }
];

const FeaturesComponent: React.FC = () => {
  return (
    <Box sx={{ py: 5,px:3, textAlign: "center", backgroundColor: "#f3f4f6" }}>
     <Typography variant="h4" fontWeight="bold" gutterBottom sx={{color:"#172554"}} className="component">
  Why Choose Us for <span
              style={{
                background:
                  "linear-gradient(-96deg, rgb(194 183 183 / 0%) 0%, rgb(255 249 220 / 4%) 28%, rgb(255, 162, 49) 100%, rgb(255 255 255 / 0%) 100%)",
                padding: "0px 2px",
                borderLeft: "2px solid rgba(253,150,16,1)",
              }}
            >Your Assignment Writing Needs?</span> 
</Typography>

      <Typography variant="body1" color="textSecondary" className="component" gutterBottom>
        Work with the best subject-matter experts anytime you need them.
      </Typography>

      <Grid container spacing={3} justifyContent="center" sx={{ mt: 3 }}>
        {features.map((feature, index) => (
          <Grid item xs={12} sm={6} md={4} key={index} className="component">
            <Card
              sx={{
                borderRadius: 2,
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                transition: "transform 0.3s ease",
                "&:hover": { transform: "translateY(-5px)" },
              }}
            >
              <CardContent sx={{ textAlign: "center" }}>
                <Avatar
                  sx={{
                    mx: "auto",
                    bgcolor: "#172554",
                    width: 56,
                    height: 56,
                    mb: 2,
                  }}
                >
                  {feature.icon}
                </Avatar>
                <Typography color={'#012f57'} variant="h6" fontWeight="bold" gutterBottom>
                  {feature.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {feature.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FeaturesComponent;
